import { StandardEvents } from '@shopify/events';

class GSProductMediaTreatment extends HTMLElement {
  #controller = new AbortController();
  #defaultImage = null;
  #variantMedia = new Map();

  connectedCallback() {
    const image = this.querySelector('.gs-product-image-treatment__cutout');
    if (!(image instanceof HTMLImageElement)) return;

    this.#defaultImage = {
      src: image.getAttribute('src') || '',
      srcset: image.getAttribute('srcset') || '',
      alt: image.getAttribute('alt') || '',
    };

    for (const entry of this.querySelectorAll('[data-gs-variant-media]')) {
      if (!(entry instanceof HTMLElement)) continue;
      const variantId = this.#normalizeId(entry.dataset.variantId);
      if (variantId) this.#variantMedia.set(variantId, entry.dataset);
    }

    const eventTarget = this.closest('.shopify-section, dialog') || document;
    eventTarget.addEventListener(StandardEvents.productSelect, this.#handleProductSelect, {
      signal: this.#controller.signal,
    });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        const eventProductId = this.#normalizeId(detail?.productId);
        const treatmentProductId = this.#normalizeId(this.dataset.productId);
        if (eventProductId && treatmentProductId && eventProductId !== treatmentProductId) return;

        this.#showVariant(detail?.resource?.id);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[gs-product-media-treatment] Variant image update failed:', error);
      });
  };

  #showVariant(variantId) {
    const image = this.querySelector('.gs-product-image-treatment__cutout');
    if (!(image instanceof HTMLImageElement) || !this.#defaultImage) return;

    const normalizedVariantId = this.#normalizeId(variantId);
    const media = normalizedVariantId ? this.#variantMedia.get(normalizedVariantId) : null;

    if (!media?.src) {
      image.src = this.#defaultImage.src;
      image.srcset = this.#defaultImage.srcset;
      image.alt = this.#defaultImage.alt;
      this.removeAttribute('data-active-variant-id');
      return;
    }

    image.src = media.src;
    image.srcset = media.srcset || media.src;
    image.alt = media.alt || this.#defaultImage.alt;
    this.dataset.activeVariantId = normalizedVariantId;
  }

  #normalizeId(value) {
    if (value === null || value === undefined) return '';
    return String(value).split('/').pop() || '';
  }
}

if (!customElements.get('gs-product-media-treatment')) {
  customElements.define('gs-product-media-treatment', GSProductMediaTreatment);
}
